<template>
	<div id="app">
		<Headnav/>
		<router-view/>
		<Footer/>
	</div>
</template>

<script>
	import Headnav from '@/components/headnav.vue'
	import Footer from '@/components/footer.vue'
	export default {
		components: { Headnav,Footer },
		created() {
		}
	}
</script>

<style>
</style>
